import { LoadResponse } from "../../models/api/load";
import { TnALocationCodeDTO } from "../../models/tna-location-codes/tna-location-code-dto";
import { TnALocationCodeFilter } from "../../models/tna-location-codes/tna-location-code-filter";
import { TnALocationCodesApiService } from "../../services/tna-location-codes/tna-location-codes-api.service";

export const checkLocationMatching = async (
  employeeId: string,
  codeOrName: string
): Promise<LoadResponse<TnALocationCodeDTO> | { error: string; items: any[] }> => {
  if (codeOrName.trim() !== "") {
    const response = await new TnALocationCodesApiService().loadItems({
      employeeId,
      codeOrName,
    } as TnALocationCodeFilter);
    return response;
  }
  return { error: "Location code or name cannot be empty", items: [] };
};
